// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1miVn","header":"ClearentDisclaimer_header__RrlWV","inner":"ClearentDisclaimer_inner__10pXS"};